module.exports = __webpack_public_path__ + "img/partner_corporativ.7e01be82.png";